/** WRP SERVICES */
/** WRP SERVICES */
/** WRP SERVICES */

const APIROOT = 'https://stackin-vue-default-rtdb.firebaseio.com';

// Returns today's date in the browser's local timezone as 'YYYY-MM-DD'
export function getLocalDateString(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}


// 'YYYY-MM-DD' --> 'Day, Mon d, YYYY'
export function getDisplayDateFromRawDate(dateString) {
  const [ year, month, day ] = dateString.split('-').map(Number); // '2025-03-28'
  const date = new Date(year, month - 1, day);
  const display = date.toLocaleDateString('en-US', {
    weekday: 'short', // Sat
    month: 'short', // Mar
    day: 'numeric', // 28
    year: 'numeric', // 2026
  });
  return {
    display,
    year: date.toLocaleDateString('en-US', { year: 'numeric' }),
    month: date.toLocaleDateString('en-US', { month: 'short' }),
    day: date.toLocaleDateString('en-US', { day: 'numeric' }),
    weekday: date.toLocaleDateString('en-US', { weekday: 'short' }),
  };
}

// returns 'YYYY-MM-DD' + days
export function addDaysToDate(dateString, days) {
  const [ year, month, day] = dateString.split('-').map(Number); // 'YYYY-MM-DD';
  const date = new Date(year, month - 1, day);

  date.setDate(date.getDate() + days);

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}`;
}

// these are the options in the <select> -- get 15 days prior, today, and tomorrow
export function getReviewStartDateOptions(today, tomorrow) {
  let allDays = [];

  // get 5 previous days
  const [ year, month, day ] = today.split('-').map(Number);
  const baseDate = new Date(year, month - 1, day);
  for (let i=15; i>=1; i--) {
    let pastDate = new Date(baseDate);
    pastDate.setDate(pastDate.getDate() - i); // subtract days

    const yyyy = pastDate.getFullYear();
    const mm = String(pastDate.getMonth() + 1).padStart(2, '0');
    const dd = String(pastDate.getDate()).padStart(2, '0');
    const d = `${yyyy}-${mm}-${dd}`;
    allDays.push({
      value: d,
      display: getDisplayDateFromRawDate(d).display,
    });
  }

  // today & tomorrow
  allDays.push(
    { value: today, display: getDisplayDateFromRawDate(today).display },
    { value: tomorrow, display: getDisplayDateFromRawDate(tomorrow).display },
  );
  // console.log('*** WRPServices > allDays ***', allDays);
  return allDays;
}



// CREATE NEW WRP
export async function createNewWRP(uId, token, wrp) {
  // returns true/responseData if successful, or throws error
  // console.log('**** starting WRPServices > saveNewWRP() ***', uId, token, wrp);


  // build the data
  const newWRP = { ...wrp };
  // const dateOfReview = '2026-04-09';
  const dateOfReview = newWRP.dateOfReview.value;
  const response = await fetch(`${APIROOT}/wrp/${uId}/${dateOfReview}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(newWRP),
  });

  // API call
  const responseData = await response.json();
  // console.log('*** createNewWRP() > responseData ****', responseData);
  // "err handling"
  if (!response.ok) {
    throw new Error(response.message || 'Failed to create new WRP');
  } else {
    return responseData;
  }

}




// READ ALL WRP's (SHALLOW - just get the dates of existing WRP's)
export async function getAllExistingWRPDates(uId, token) {
  // console.log('**** starting getAllExistingWRPDates(uId, token) ******', uId, token);

  // API Call
  const response = await fetch(`${APIROOT}/wrp/${uId}.json?auth=${token}&shallow=true`);
  const responseData = await response.json();
  // console.log('************* response *****************', response);

  // response
  if (!response.ok) {
    console.log('*** err ***', response);
    throw new Error(response.message || 'Failed to get all existing WRP ids');
  }

  if (responseData) {
    // console.log('**** WRPServices > getAllExistingWRPDates() > responseData *****', responseData);
    return responseData;
  } else {
    return null;
  }


}

// READ ONE WRP - BY ID ('YYYY-MM-DD')
export async function getOneWRPById(uId, token, wrpId) {
  // console.log('**** starting getOneWRPById(uId, token, wrpId) ******', uId, token, wrpId);

  // API Call
  const response = await fetch(`${APIROOT}/wrp/${uId}/${wrpId}.json?auth=${token}`);
  const responseData = await response.json();
  // console.log('************* response *****************', response);

  // response
  if (!response.ok) {
    console.log('*** err ***', response);
    throw new Error(response.message || 'Failed to get one WRP by id ' + wrpId);
  }

  let wrpObj = null;
  if (responseData) {
    // console.log('**** WRPServices > getOneWRPById() > responseData *****', responseData);
    wrpObj = responseData;
  }
  return wrpObj;
}

// READ ONE WRP - LATEST -- return wrpObj || null
export async function getLatestWRPFromDbase(uId, token) {

  // API Call
  const response = await fetch(`${APIROOT}/wrp/${uId}.json?auth=${token}&orderBy="$key"&limitToLast=1`);
  // &orderBy="order"&limitToLast=1
  // &orderBy="$key"&limitToLast=1
  const responseData = await response.json();
  // console.log('************* response *****************', response);

  // response
  if (!response.ok) {
    console.log('*** err ***', response);
    throw new Error(response.message || 'Failed to get latest WRP');
  }

  let wrpObj = null;
  if (responseData) {
    // console.log('**** WRPServices > getLatestWRPFromDbase() > responseData *****', responseData);
    wrpObj = responseData;
  }
  return wrpObj;

}

// get a dayToReview object
export async function getADayToReviewFromDbase(uId, token, day) {
  // returns an object or empty object

  // console.log('*** starting getAllWinsForTodayFromDbase(uId, token, today) ***', uId, token, today);
  const response = await fetch(`${APIROOT}/days/${uId}/${day}.json?auth=${token}`);
  const responseData = await response.json();
  // err handling
  if (!response.ok) {
    throw new Error(response.message || 'Failed to get a day to review from dbase');
  }
  return responseData ? responseData : {};
}




// UPDATE ONE WRP PROP
export async function updateOneWRPProp(uId, token, date, endpoint, newText) {
  console.log('*** WRP Services >> updateOneWRPProp() ***', endpoint, newText);

  // api call
  let data = {};
  data[endpoint] = newText;
  const response = await fetch(`${APIROOT}/wrp/${uId}/${date}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(data)
  });
  const responseData = await response.json();

  if (!response.ok) {
    // console.log(responseData);
    throw new Error(response.message || 'Failed to update a WRP.prop');
  } else {
    return responseData;
  }

}


// DELETE ONE WHOLE WRP, by date (wrpId)
export async function deleteOneWRP(uId, token, wrpId) {
  console.log('*** WRP Services >> deleteOneWRP ***', wrpId);

  // API call
  const response = await fetch(`${APIROOT}/wrp/${uId}/${wrpId}.json?auth=${token}`, {
    method: 'DELETE',
  });
  const responseData = await response.json();
  console.log('*** deleteOneWRP() >> responseData ***', responseData);

  if (!response.ok) {
    throw new Error(response.message || 'Failed to delete a WRP');
  } else {
    return responseData;
  }

}





// CREATE / UPDATE WRP DRAFT
export async function saveWRPDraft(uId, token, draft) {
  const response = await fetch(
    `${APIROOT}/users/${uId}/wrp-draft.json?auth=${token}`,
    {
      method: 'PATCH',
      body: JSON.stringify(draft),
    }
  );

  const responseData = await response.json();

  if (!response.ok) {
    throw new Error(
      responseData?.error ||
      response.message ||
      'Failed to save WRP draft'
    );
  }

  return responseData;
}


// READ WRP DRAFT
export async function getWRPDraft(uId, token) {
  const response = await fetch(`${APIROOT}/users/${uId}/wrp-draft.json?auth=${token}`);

  const responseData = await response.json();

  if (!response.ok) {
    throw new Error(
      responseData?.error ||
      response.message ||
      'Failed to get WRP draft'
    );
  }

  return responseData || null;
}


// DELETE WRP DRAFT
export async function deleteWRPDraft(uId, token) {
  const response = await fetch(
    `${APIROOT}/users/${uId}/wrp-draft.json?auth=${token}`,
    { method: 'DELETE', }
  );

  const responseData = await response.json();

  if (!response.ok) {
    throw new Error(
      responseData?.error ||
      response.message ||
      'Failed to delete WRP draft'
    );
  }

  return responseData;
}

